import styled from 'styled-components';

import { Button } from '../../../shared/components/Button';
import { colorPalette } from '../../../shared/components/variables';

import { useAlphabetHeight } from './useAlphabetHeight';

const alphabet = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));

interface RiderAlphabetFilterProps {
  availableLetters: string[];
  selectedLetter?: string;
  onSelectLetter: (letter: string) => void;
  onSelectAll: () => void;
  onHeightChange: (height: number) => void;
}

export const RiderAlphabetFilter = ({
  availableLetters,
  selectedLetter,
  onSelectLetter,
  onSelectAll,
  onHeightChange,
}: RiderAlphabetFilterProps) => {
  const ref = useAlphabetHeight(onHeightChange);

  return (
    <FilterGroup ref={ref} role="group" aria-label="Filter riders by first letter" data-testid="alphabet-selector">
      {alphabet.map((letter) => (
        <LetterButton
          key={letter}
          type="button"
          variant="text"
          disabled={!availableLetters.includes(letter)}
          aria-pressed={selectedLetter === letter}
          onClick={() => onSelectLetter(letter)}
          data-testid="alpha-anchor"
        >
          {letter}
        </LetterButton>
      ))}
      <LetterButton
        type="button"
        variant="text"
        aria-pressed={!selectedLetter}
        onClick={onSelectAll}
        data-testid="all-link"
      >
        All
      </LetterButton>
    </FilterGroup>
  );
};

const FilterGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 4px 0 8px;
`;

const LetterButton = styled(Button)`
  && {
    flex: 0 0 auto;
    min-width: 44px;
    min-height: 44px;
    padding: 4px;
    font-size: 18px;
    color: ${colorPalette.navy40};
    border-radius: 4px;

    &[aria-pressed='true'] {
      font-weight: 700;
      text-decoration: underline;
      background: ${colorPalette.navy95};
    }

    &.Mui-disabled {
      color: ${colorPalette.neutral350};
    }

    &:focus-visible {
      outline: 2px solid ${colorPalette.navy40};
      outline-offset: 2px;
    }
  }
`;
